import templateUrl from "emun.invoice/inv/inv-list.htm";

export default () => ({
  templateUrl
});
